import { Star } from "lucide-react";
import { motion } from "framer-motion";

function GoogleG({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.57 5.57 0 0 1-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.27 14.29A7.2 7.2 0 0 1 4.89 12c0-.8.14-1.57.38-2.29V6.62H1.29a12 12 0 0 0 0 10.76l3.98-3.09z" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42A11.97 11.97 0 0 0 12 0 11.99 11.99 0 0 0 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
    </svg>
  );
}

export default function GoogleBadge({ dark = false }) {
  return (
    <motion.a
      href="https://www.google.com/maps?cid=17070869793711951641"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-rating-badge"
      whileHover={{ y: -3 }}
      transition={{ duration: 0.25 }}
      className={`inline-flex items-center gap-4 px-6 py-4 border transition-shadow duration-300 hover:shadow-[0_16px_40px_-16px_rgba(11,19,32,0.35)] ${
        dark ? "bg-navy-800 border-navy-600" : "bg-white border-sandline"
      }`}
    >
      <GoogleG />
      <div>
        <div className="flex items-center gap-2">
          <span className={`font-heading font-black text-2xl leading-none ${dark ? "text-offwhite" : "text-navy"}`}>5.0</span>
          <span className="flex gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={14} fill="#FBBC04" strokeWidth={0} />
            ))}
          </span>
        </div>
        <p className={`mt-1 text-xs font-semibold tracking-wide ${dark ? "text-offwhite/50" : "text-slateblue"}`}>
          Based on 7 Google reviews
        </p>
      </div>
    </motion.a>
  );
}
